import { render } from "./DemandExpress.vue?vue&type=template&id=e4464f02"
import script from "./DemandExpress.vue?vue&type=script&lang=js"
export * from "./DemandExpress.vue?vue&type=script&lang=js"

import "./DemandExpress.vue?vue&type=style&index=0&id=e4464f02&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__